// preventPullToRefresh.js
/**
 * Prevent the pulling refresh on the Android Chrome
 * subscribe the touchstart and the touchmove events
 * @param {string|HTMLElement} element - the string selector or html element
 * @return {Function} an unsubscribe function to remove the event listeners
 */
function preventPullToRefresh(element) {
  let prevent = false;
  let el = element;
  let lastTouchY;
  if (typeof element === 'string') {
    el = document.querySelector(element);
  }

  function setTouchStartPoint(event) {
    lastTouchY = event.touches[0].screenY;
  }

  function isScrollingUp(event) {
    const touchY = event.touches[0].screenY;
    const delta = touchY - lastTouchY;

    lastTouchY = touchY;
    return delta > 0;
  }

  function handleTouchStart(event) {
    if (event.touches.length !== 1) {
      return;
    }

    const scrollY =
      window.pageYOffset ||
      document.body.scrollTop ||
      document.documentElement.scrollTop;
    prevent = scrollY === 0;
    setTouchStartPoint(event);
  }

  function handleTouchMove(event) {
    if (prevent) {
      prevent = false;

      if (isScrollingUp(event)) {
        return event.preventDefault();
      }
    }
  }

  el.addEventListener('touchstart', handleTouchStart);
  el.addEventListener('touchmove', handleTouchMove, { passive: false });

  return function removeListeners() {
    el.removeEventListener('touchstart', handleTouchStart);
    el.removeEventListener('touchmove', handleTouchMove, { passive: false });
  };
}

export default preventPullToRefresh;
